<template>
   <div class="fuzzy-matching-box">
        <!-- 安全教育和新闻 -->
        <div class="header-Top-Box">
            <!-- <h1 class="anquan-text">安全教育和新闻</h1> -->
            <div class="school-seacher">
                <el-row>
                    <el-col :span="4">
                        <el-form-item label="标题:" >
                            <el-input  v-model="Dform.title" placeholder=''></el-input>
                        </el-form-item>
                     </el-col >
                     <el-col :span="4" >
                        <el-form-item  label="发布人："  >
                            <el-input v-model="Dform.publishUserName"  placeholder=''></el-input>
                        </el-form-item>
                     </el-col >
                     <el-col :span="4">
                    <el-form-item label="时间:">
                      <el-input v-model="Dform.gradeName" placeholder=''></el-input>
                    </el-form-item>
                  </el-col >
                  <el-col :span="4">
                    <el-form-item label="To:">
                      <el-input v-model="Dform.className" placeholder=''></el-input>
                    </el-form-item>
                  </el-col >
                        <el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
                        <el-button type="primary" class="query-button" @click="AddclickXinxi">发布信息</el-button>
                        <el-button type="primary" class="query-button" @click="piliangClick">批量删除</el-button>
            </el-row>
            </div>
        </div>
        <div class="center-table-box"> 
            <el-table
                 stripe
                :border="true"
                class="table-Style"
                ref="multipleTable"
                :header-cell-style="{background:'#EDF6FF',color:'#000',}"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column
                type="selection"
                >
                </el-table-column>
                <el-table-column
                label="标题"
                >
                <template #default="scope">
                            <span >{{ JSON.parse(scope.row.description).title }}</span>
                 </template>
                </el-table-column>
                <el-table-column
                prop="created"
                label="发布时间"
                >
              </el-table-column>
                <el-table-column
                prop="publishUserName"
                label="发布人"
              >
              </el-table-column>
                <el-table-column
                label="类型"
              >
              <template #default="scope">
              <span v-if="scope.row.type == 11">{{'新闻资讯'}}</span>
              <span v-if="scope.row.type == 12">{{'安全教育'}}</span>

            </template>
                </el-table-column>
                <el-table-column
                label="操作"
              >
                <template #default="scope">
                <!-- <div v-if="userId == scope.row.id"> -->
                    <el-button type="text"  class="shanchuBtn" @click="deleteClick(scope.row)">删除</el-button>
                    <el-button type="text" class="xiugaiBtn" @click="xiugai(scope.row)" >修改</el-button>
                <!-- </div> -->
                </template>
            </el-table-column>
            </el-table>
            <div class="block-fenye" >
            <el-pagination
                :small="small"
                :disabled="disabled"
                :background="background"
                layout="prev, pager, next, jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
          </div>
        </div>
        <fabuAdd @backClick="backClick" v-if="fabuAddShow" :reviseItem="reviseItem"></fabuAdd>
   </div>
</template>
<script>
import {noticeList,noticeListDelete} from '@/assets/api/schoollog'
import { findTeacherInfo } from '@/assets/api/renyuan';
import fabuAdd from './fabuAdd/add.vue'

export default {
   name: '',
   components: {
    fabuAdd
   },

   props: {
     
   },
   data() {
     return {
       fabuAddShow:false,
       Dform:{
        entTime:'',
        publishUserName:'',
        startTime:'',
        title:'',
       },
       pageInfo:{
        page:"1",
        pageSize:'10'
       },
       total: '1',
       deleteList:[],
       tableData:[],
       objLookTeacher: {},
       userId: JSON.parse(localStorage.getItem('user')).id,
       reviseItem: {}
     }
   },
   created(){
    this.LookTeacher()
   },
   mounted() {
     
   },
   methods: {
    entrylogClick(){
      this.noticeListSeacher()
    },
    LookTeacher() {
        const params = {
          userId: JSON.parse(localStorage.getItem('user')).id,
        }
        findTeacherInfo(params).then((res) => {
          this.objLookTeacher = res.data.data
          console.log(res.data.data, '查看当前登录人权限');
          this.noticeListSeacher()

        }).catch((err) => {
          console.log(err);
        })
      },
    // 批量删除
    piliangClick () {
      let arr = []
      for (let item of this.deleteList) {
        console.log(item.id,777777);
        arr.push(item.id)
      }
      let params = {
        id: arr
      }
      noticeListDelete(params).then((res)=> {
        console.log(res,'删除');
        this.$message('批量删除成功！');
        this.noticeListSeacher()
      }).catch((err)=> {
        console.log(err);
      })
    },
    xiugai (item) {
      this.reviseItem = item
      this.fabuAddShow = true
    },
    //删除
    deleteClick (item) {
      console.log(item,7777);
      let params = {
        id:item.id 
      }
      noticeListDelete(params).then((res)=> {
        console.log(res,'删除');
        this.$message({
                    type: 'success',		
                    message:'删除成功！'
                });
        this.noticeListSeacher()
      }).catch((err)=> {
        console.log(err);
      })
    },
    handleSelectionChange (val) {
      this.deleteList = val
      console.log(this.deleteList,'多选7777');
    },
    //列表
    noticeListSeacher(){
      let params ={}
      if ( this.objLookTeacher.schoolId !=  null && this.objLookTeacher.schoolId !=  '' ) {
        params= {
            entTime:this.Dform.entTime,
            publishUserName:this.Dform.publishUserName,
            startTime:this.Dform.startTime,
            title:this.Dform.title,
            page:this.pageInfo.page,
            pageSize:this.pageInfo.pageSize,
            userId: JSON.parse(localStorage.getItem('user')).id,
        }
      } else {
        params= {
            entTime:this.Dform.entTime,
            publishUserName:this.Dform.publishUserName,
            startTime:this.Dform.startTime,
            title:this.Dform.title,
            page:this.pageInfo.page,
            pageSize:this.pageInfo.pageSize,
        }
      }
        noticeList(params).then((res)=> {
            // console.log(res,1);
            this.tableData = res.data.data.list
            this.total = res.data.data.total
        }).catch((err)=> {
            console.log(err,2);

        })
    },
     AddclickXinxi(){
        if (this.objLookTeacher.schoolId != '' && this.objLookTeacher.schoolId != null) {
            this.fabuAddShow = true
        } else {
            this.$message({
                message: '暂无权限进行该操作！',
                type: 'warning'
            });
        }
     },
     backClick(){
        this.reviseItem= {}
        this.fabuAddShow = false
        this.noticeListSeacher()
     },
     handleSelectionChange (val) {
      this.deleteList = val
      console.log(this.deleteList,'多选7777');
    },
    handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.pageInfo.page = val
        this.noticeListSeacher()
    },
   }
};
</script>
<style lang='scss' scoped>
    .fuzzy-matching-box{
        height: 96%;
        .header-Top-Box{
            height: 10%;
            background-color: #fff;
            border-radius: 10px;
            // display: flex;
            // align-items: center; /*垂直居中*/
            padding-top: 30px;
           .anquan-text{
            // line-height:-20% !important;
            font-size: 18px;
            font-weight: 700;
            // margin-left: 20px;
            width: 50%;

           }
            :deep() {
                .el-col-6{
                    // margin-right: 50px;
                    margin-left: 20px;
                    width: 50px;

                }
                .el-row{
                    height: 40px;
                    line-height: 40px !important;
                    text-align: center;
                    width: 100%;
                    
                }
                .el-input--small .el-input__inner{
                    height: 30px;
                    
                }
                .el-input--small .el-input__wrapper{
                    border-radius: 15px;
                }
                .el-form-item--small .el-form-item__label {
                    line-height: 30px !important;
                    font-size: 15px;
                    font-weight: 700;
                    margin-left: 20px;
                }
                .el-input__inner {
                    width: 50px;
                    margin-right:50px !important;
                    border-radius: 15px;
                }
                .query-button{
                    margin-left: 40px;
                    // background-color:#1BC896;
                    font-size: 16px;
                    height: 30px;
                    border-radius:15px
                }

            
           }

        }
        .center-table-box{
            height: 86%;
            margin-top: 20px;
            background-color: #fff;
            border-radius: 10px;
            padding: 20px;
            .table-Style{
                // border-radius: 1 px;
            }
            .shanchuBtn{
                font-size: 15px;
                font-weight: 700;
                color: red;
            }
            .xiugaiBtn{
                font-size: 15px;
                font-weight: 700;
                // color: #1BC896;
            }
            :deep() {
                .el-table th.el-table__cell>.cell{
                    height: 30px;
                    line-height: 30px;
                    font-weight: 700;
                    text-align: center;

                }
                .el-table .cell {
                    text-align: center;

                }
                .el-table__header{
                    line-height: 30px !important;
                    height: 30px;
                    font-size: 15px;
                    font-weight: 700;
                    border-radius: 15px;

                }
                .el-table--enable-row-transition .el-table__body td.el-table__cell {
                    // border: none;
                    height: 40px;
                    font-size: 16px;
                }
                }
            .block-fenye{
                margin-top: 20px;
                margin-left: 40%;
            }
        }
    }
</style>